import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=3f921121&"
import script from "./AppHeader.vue?vue&type=script&lang=ts&"
export * from "./AppHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports